import {Card, Col, Row} from "antd";
import {useEffect, useState} from "react";
import Api from "../../../../services/Api";
import dayjs from "dayjs";
import flexCurrency from "../../../../utils/FlexCurrency";

const RestaurantComponent = () => {
    const [restaurantData, setRestaurantData] = useState([]);

    const getRestaurantData = async (baslangicTarihi, bitisTarihi) => {
        try {
            const res1 = await Api.get(`/api/ToyaPos/ZraporuAvansli?baslangicTarihi=${encodeURIComponent(baslangicTarihi)}&bitisTarihi=${encodeURIComponent(bitisTarihi)}`);
            const res2 = await Api.get(`/api/ToyaPos/ZraporuAlinmislarAvansli?baslangicTarihi=${encodeURIComponent(baslangicTarihi)}&bitisTarihi=${encodeURIComponent(bitisTarihi)}`);
            setRestaurantData([...res1.data, ...res2.data]);
        } catch (error) {
            console.error("Restoran verileri alınırken hata oluştu:", error);
        }
    };

    const toplamTutarlar = () => {
        // nakit, kredi kartı ve toplam tutar dönecek
        let nakitToplam = 0;
        let krediKartıToplam = 0;
        let toplamTutar = 0;
        let fisTutari = 0;

        // data.Nakit leri topla

        restaurantData.forEach(item => {
            if (item.Nakit) {
                nakitToplam += parseFloat(item.Nakit);
            }
            if (item.Kart) {
                krediKartıToplam += parseFloat(item.Kart);
            }

            if (item.FisTutari) {
                fisTutari += parseFloat(item.FisTutari);
            }
        });

        toplamTutar = nakitToplam + krediKartıToplam;

        return {
            nakitToplam,
            krediKartıToplam,
            toplamTutar,
            fisTutari
        }
    }

    const LokasyonToplamlari = () => {
        let TERAS = 0;
        let SALON = 0;
        let BUFE = 0;
        let masalar = {};

        restaurantData.forEach(item => {
            const tutar = parseFloat(item.FisTutari || 0);

            if (item.device_id === 3) {
                TERAS += tutar;
            } else if (item.device_id === 1) {
                SALON += tutar;
            } else if (item.device_id === 4) {
                BUFE += tutar;
            }

            if (item.masa) {
                masalar[item.masa] = (masalar[item.masa] || 0) + tutar;
            }
        });

        return { TERAS, SALON, BUFE, masalar };
    }

    useEffect(() => {
        const baslangicTarihi = dayjs().startOf("day").format("YYYY-MM-DD HH:mm:ss.SSS");
        const bitisTarihi = dayjs().endOf("day").format("YYYY-MM-DD HH:mm:ss.SSS");
        getRestaurantData(baslangicTarihi, bitisTarihi);
    }, []);

    return(<Row gutter={[10,10]}>
        <Col span={24}>
            <Card title={"Resturant Gelirleri"} >
                <Row gutter={[10, 10]}>
                    <Col span={12}>
                        <Card size={"small"} title={"Nakit Tutar"} style={{textAlign: "center", fontWeight:"bold"}}>
                            <div style={{fontWeight:"bold", textAlign:"center"}}>
                                <div>
                                    <img width={50}
                                         src={process.env.PUBLIC_URL + '/assets/images/kasa.png'}
                                         alt={""}></img>
                                </div>
                                <div>
                                    NAKİT KASA
                                </div>
                            </div>
                            {flexCurrency(toplamTutarlar().nakitToplam)} ₺
                        </Card>
                    </Col>
                    <Col span={12}>
                        <Card size={"small"} title={"Kredi Kartı Tutar"} style={{textAlign: "center", fontWeight:"bold"}}>
                            <div style={{fontWeight: "bold", textAlign: "center"}}>
                                <img width={50}
                                     src={process.env.PUBLIC_URL + '/assets/images/kredi-karti.png'}
                                     alt={""}></img>

                                <div>
                                    KREDİ KARTI
                                </div>
                            </div>
                            {flexCurrency(toplamTutarlar().krediKartıToplam)} ₺
                        </Card>
                    </Col>
                    <Col span={24}>
                        <Card size={"small"} title={"Toplam Tutar"} style={{textAlign: "center", fontWeight:"bold", fontSize:"30px", color:"green"}}>
                            {flexCurrency(toplamTutarlar().toplamTutar)} ₺
                        </Card>
                    </Col>
                </Row>

                <Row gutter={[10,10]} className={"mt-1"}>

                    <Col span={24}>
                        <Card size={"small"} title={"TERAS"} style={{textAlign: "center", fontWeight:"bold"}}>
                            {LokasyonToplamlari().TERAS ? flexCurrency(LokasyonToplamlari().TERAS) : 0} ₺
                        </Card>
                    </Col>
                    <Col span={24}>
                        <Card size={"small"} title={"BÜFE"} style={{textAlign: "center", fontWeight:"bold"}}>
                            {LokasyonToplamlari().BUFE ? flexCurrency(LokasyonToplamlari().BUFE) : 0} ₺
                        </Card>
                    </Col>
                    <Col span={24}>
                        <Card size={"small"} title={"SALON"} style={{textAlign: "center", fontWeight:"bold"}}>
                            {LokasyonToplamlari().SALON ? flexCurrency(LokasyonToplamlari().SALON) : 0} ₺
                        </Card>
                    </Col>
                </Row>
            </Card>
        </Col>
    </Row>)
}

export default RestaurantComponent
